export default "__VITE_ASSET__v9hVfKTS__"